module.exports = __webpack_public_path__ + "img/dango.8b4a1106.png";